import React, { useState, useEffect } from "react";
import axios from "axios";
import ListeaCadetesReempadronar from "./ListeaCadetesReempadronar";
import socket from "../tools/socke";
import SelectorSeccionConDNI from "../Cuerpo/SelectorSeccionConDNI";
import comprueboPermisos from "../tools/comprueboPermisos";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";

const ReempadronaCadete = () => {
  const [visible, setVisible] = useState(false);
  const [filtro, setFiltro] = useState("");
  const [cadetesFiltrados, setCadetesFiltrados] = useState([]);
  const [promocionSeleccionada, setPromocionSeleccionada] = useState("");
  const [modo, setModo] = useState("reempadronar"); // 🔄 | 📍

  const Usuario = ObtieneDatosCookies();

  // ===== WebSocket =====
  useEffect(() => {
    socket.on("estadoActualizable", () => {
      if (filtro !== "") {
        obtieneCadete(filtro);
      }
    });

    return () => {
      socket.off("estadoActualizable");
    };
  }, [filtro]);

  // ===== Backend =====
  const obtieneCadete = async (dato) => {
    try {
      if (dato.length > 1) {
        const username = process.env.REACT_APP_KEY;
        const password = process.env.REACT_APP_PASS;
        const token = btoa(`${username}:${password}`);

        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/devuelveCadete/${dato}`,
          { estado: "activo" },
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        );

        setVisible(true);
        setCadetesFiltrados(response.data.datos || []);
      } else {
        setCadetesFiltrados([]);
      }
    } catch (error) {
      console.error("Error en la petición", error);
    }
  };

  // ===== Input =====
  const handleInputChange = (e) => {
    const texto = e.target.value;
    setFiltro(texto);
    obtieneCadete(texto);
  };

  // ===== Emit socket =====
  const enciendeLectores = (va) => {
    obtieneCadete(filtro);
    setPromocionSeleccionada(va.Promocions.nombre);
    socket.emit("reempadrone", va.Promocions.nombre);
  };

  return (
    <div style={{ padding: "10px" }}>
      <h3 style={{ textAlign: "center" }}>
        Servicio de Reempadronamiento y Asignación de Secciones ISeP
      </h3>

     
      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          margin: "20px 0",
        }}
      >
        <button
          onClick={() => setModo("reempadronar")}
          style={{
            flex: "1",
            padding: "12px",
            borderRadius: "10px",
            border: "1px solid #d1d5db",
            background: modo === "reempadronar" ? "#2563eb" : "#fff",
            color: modo === "reempadronar" ? "#fff" : "#000",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          🔄 Reempadronar cadete
        </button>

        {comprueboPermisos(Usuario.funcion, "Asigno Cadete a Seccion") && (
          <button
            onClick={() => setModo("seccion")}
            style={{
              flex: "1",
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #d1d5db",
              background: modo === "seccion" ? "#16a34a" : "#fff",
              color: modo === "seccion" ? "#fff" : "#000",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            📍 Asignar sección
          </button>
        )}
      </div>

 
      {modo === "seccion" && (
        <SelectorSeccionConDNI />
      )}

      
      {modo === "reempadronar" && (
        <>
          <div>
            <input
              type="text"
              placeholder="Buscar por apellido o DNI"
              value={filtro}
              onChange={handleInputChange}
              style={{
                padding: "10px",
                fontSize: "16px",
                marginBottom: "10px",
                width: "100%",
                maxWidth: "600px",
                boxSizing: "border-box",
              }}
            />
          </div>

          {visible && cadetesFiltrados.length > 0 && (
            <ListeaCadetesReempadronar
              actualiza={(value) => enciendeLectores(value)}
              items={cadetesFiltrados}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ReempadronaCadete;
